module.exports = {
  title: 'React Native Lock Screen Smile Animation 🙂🙃',
  author: 'Enzo Manuel Mangano',
  date: '2022-12-07',
  slug: 'mobile-input',
  tags: ['reanimated', 'skia'],
};
